import PropTypes from 'prop-types';
import React from 'react';
import { getCurrentServiceURL } from '../utils/commons';

import PagesIcon from '../assets/images/landing_optimizer/pages.svg';
import DomainsIcon from '../assets/images/landing_optimizer/domains.svg';
import DownloadLeadsIcon from '../assets/images/landing_optimizer/download_leads.svg';
import EditGlobalsIcon from '../assets/images/landing_optimizer/edit_globals.svg';
import StatisticsIcon from '../assets/images/landing_optimizer/statistics.svg';

const iconMap = {
  pages: PagesIcon,
  domains: DomainsIcon,
  download_leads: DownloadLeadsIcon,
  edit_globals: EditGlobalsIcon,
  statistics: StatisticsIcon,
};

const addCompanyIdToUrl = (url, companyId, hasToShowCompanyInUrl) => {
  if (!companyId) return url;
  if (!hasToShowCompanyInUrl) return url;

  if (url.indexOf('?') === -1) {
    return url + '?company_id=' + companyId;
  }
  return url + '&company_id=' + companyId;
};

const getItemURL = (item, companyId) => {
  return addCompanyIdToUrl(
    getCurrentServiceURL(item.service) + item.path,
    companyId,
    item.hasToShowCompanyInUrl
  );
};

const getIcon = (item, isEmBlue) => {
  const Icon = iconMap[item.key];
  return isEmBlue && item.hasIcon && <img src={Icon} alt="" width="16" height="16" />;
};

const DropdownItem = ({ item, isActive, toggle, companyId, isEmBlue }) => {
  return (
    <li
      id={`${item.service}-${item.key}`}
      className={`${isActive ? 'active' : ''}`}
      data-service={item.service}
      data-key={item.key}
    >
      <a data-bypass={true} href={getItemURL(item, companyId)} onClick={toggle} title={item.title}>
        {getIcon(item, isEmBlue)}
        {item.title}
      </a>
    </li>
  );
};

DropdownItem.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    service: PropTypes.string.isRequired,
    hasToShowCompanyInUrl: PropTypes.bool,
    hasIcon: PropTypes.bool,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  companyId: PropTypes.string,
  isEmBlue: PropTypes.bool,
};

export default DropdownItem;
